import * as React from 'react';
import { Theme } from '@mui/styles';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import {Button} from '@mui/material';
import { Typography } from '@mui/material';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {Grid} from '@mui/material';

type State = {
};

interface Props extends React.HTMLProps<HTMLDivElement> {
   classes: any;
   open: boolean;
   confirmationMessage: string;
   onConfirm: ()=>void;
   onClose: ()=>void
   isTerminal?: boolean;
  }

  const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 500
    },
    modalTitle: {
        padding: "0px 0px 20px 0px"
    },
    gridItem: {
        paddingBottom: "0px !important;",
        paddingTop: "0px !important;"
    },
    controlContainer: {
        width: "100%",
        padding: 0
    },
    dangerButton: {
        backgroundColor: "#af0202",
        '&:hover': {
            backgroundColor: "#5D0A0A !important"
        }
    }
})

class SimpleConfirmationModal extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {}
      }

    UNSAFE_componentWillReceiveProps(nextProps:Props) {
        this.setState({open: nextProps.open})
    }


    handleConfirm = () => {
        this.props.onConfirm()
        this.props.onClose()
    }

    handleDeny = () => {
        if (this.props.onDeny) {
            this.props.onDeny()
        }
        
        this.handleClose({}, "")
    }

    handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            this.props.onClose()
        }
    }

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        const {confirmationMessage, open} = this.props

        let actionButtonClass = classes.primaryButton 
        if(this.props.isTerminal){
            actionButtonClass = classes.dangerButton 
        }

        return (
            <Dialog
                className={classes.modal}
                open={open}
                onClose={this.handleClose}
            >   
                <DialogContent className={classes.modalContent}>
                { false && 
                    <DialogTitle className={classes.modalTitle}>
                        Confirm
                    </DialogTitle>  
                }
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography variant="subtitle1">{confirmationMessage}</Typography> 
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button 
                        id="noButton"
                        variant="contained"
                        color="inherit"
                        onClick={this.handleDeny}>
                        No
                    </Button>
                    <Button 
                        id="yesButton"
                        autoFocus={true}
                        variant="contained"
                        color="primary"
                        className={actionButtonClass} 
                        onClick={this.handleConfirm}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(SimpleConfirmationModal);